import api from '../../api/index';
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    appId: {
      type: String,
      required: true,
      value: "",
    },
    alive_id: {
      type: String,
      required: true,
      value: "",
    },
    userId: {
      type: String,
      required: true,
      value: "",
    },
    red_packet_id: {
      type: String,
      required: true,
      value: "",
    },
  },

  /**
   * 组件的初始数据
   */
  data: {
    detailInfo: {},
  },
  lifetimes: {
    attached: function() {
      this.getDetail()
    },
  },
  /**
   * 组件的方法列表
   */
  methods: {
      // 获取红包记录详情
    getDetail() {
      let params = {
        app_id: this.data.appId,
        alive_id: this.data.alive_id,
        user_id: this.data.userId,
        resource_type: 4,
        red_packet_id: this.data.red_packet_id,
        page: 1,
        limit: 1000
      }
      wx.showLoading({
        title: '加载中',
      })
      api.getRedPacketRecordDetail(params).then(res => {
        wx.hideLoading()
        if (res.data.code === 0) {
          let data=res.data.data;
          console.log(data,'data')
          let sendInfo=data.record_list.filter((item)=>item.user_id===data.send_info.user_id);
          let now_price = 0
          if(sendInfo.length){
            data.record_list.map((item,index)=>{
              now_price += Number(item.money) 
              if(item.user_id===data.send_info.user_id){
                return data.record_list.unshift(data.record_list.splice(index,1)[0]);
              }
            })
          }
          data.send_info.now_price = now_price;
          this.setData({
            detailInfo:data
          })
        }
      })
    },
  }
})
